import React from 'react';

import Aux from './../../../hoc/_Aux';

import * as constantArticle from './../../../conf/constantArticle';
import likesAsset from './../../../assets/images/icons/like_article_home.svg';
import playAsset from './../../../assets/images/icons/play.svg';
import Zigzag from '../../UI/Common/Shapes/Zigzag';

/**
 * Container used for displaying a list of article's preview for HP and Thematic  
 */
const ArticleBloc = (props) => {

    let blocOutput = [];
    let blocPosition = (props.position==="left" || props.position==="right")?" col-"+props.position:"";
    let articleClasses = '';
    let extraContent = [];

    const isthematicListDisplay = (typeof props.isthematicList !== 'undefined' && props.isthematicList);
    
    

    if ( typeof props.type !== 'undefined' ){
        articleClasses += 'article';

        //-- Only display this shape on HP for first main article
        if ( props.index===1 && !isthematicListDisplay ){
          extraContent.push(
            <div key="key-main-article-shape" className="yellow-shape" >
              <Zigzag color="#ffde39" translateXaxis="0" />
            </div>
            );
          extraContent.push(<div key='bg-overlay' className="gradient-bg"></div>); 
          
          //-- Adding main class
          articleClasses += ' main';
        }


        switch ( props.type ) {
            case constantArticle.DOCUMENT_TYPE_DOC:
                articleClasses += " image";
                break;

            case constantArticle.DOCUMENT_TYPE_VIDEO:
                articleClasses += " video";

                const vidStyle = { 'backgroundImage': 'url('+playAsset+')', 
                                    'backgroundSize' : 'cover',
                };
                extraContent.push(<span key={`article-bloc-vid-${props.articleId}`} className="video-icon" style={vidStyle}></span>)
                break; 
            default:     
        }

        if ( props.likes > 0 ) {
          extraContent.push(
              <span  key="key-main-article-likes" className="likes">
                  <img src={likesAsset} className="yellow-likes" alt='Nombre de like'/>
                  {props.likes}
              </span>);
        }

        //-- Adding col-{position} class
        articleClasses +=  blocPosition;

        if(articleClasses!==''){
            blocOutput = ( 
                <div 
                        key={`blockoutput-articleBloc-${props.articleId}`}
                        className={articleClasses} 
                        onClick={() => props.articleClicked(props.articleId) } 
                        style={{'backgroundImage': `url(${props.picture})`,
                                'backgroundSize' : 'cover',
                                'backgroundPosition':'50% 50%'
                        }}
                    >

                    <div className="titles"> 
                        { (isthematicListDisplay)? 
                          []
                        :
                          <h4 onClick={(e)=> { e.preventDefault(); return props.thematicClicked(props.thematicUrl) }}>{props.thematic }</h4>
                        }
                       
                       <h3><span className="highlight">{props.title}</span></h3>
                    </div>
    
                    {extraContent}
                </div>);
        }

    }

    return(
           <Aux>
               {blocOutput}
           </Aux> 

    )
};

export default ArticleBloc;


// WEBPACK FOOTER //
// ./src/containers/Article/ArticleBloc/ArticleBloc.js